import React, { useState } from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../variants.jsx";
import { experiencesData } from "../utils/data.jsx";

const Experiences = () => {
	// Store the index of the selected experience; null means none selected.
	const [selectedExpIndex, setSelectedExpIndex] = useState(null);

	// Toggle selection: if the same exp is clicked, deselect it.
	const handleExpClick = (index) => {
		setSelectedExpIndex((prevIndex) => (prevIndex === index ? null : index));
	};

	return (
		<section className="w-full pt-10 px-5">
			<div>
				<motion.h2
					variants={fadeIn("down")}
					initial="hidden"
					whileInView="show"
					viewport={{ once: true, amount: 0.4 }}
					className="text-3xl font-bold text-white text-left px-2"
				>
					Experiences
				</motion.h2>
				<div className="flex flex-col xl:flex-row sm:items-center pt-3">
					{/* Experience list */}
					<motion.div
						variants={fadeIn("right")}
						initial="hidden"
						whileInView="show"
						viewport={{ once: true, amount: 0.4 }}
						className="w-full"
					>
						{experiencesData.map((exp, index) => (
							<div
								key={index}
								onClick={() => handleExpClick(index)}
								className="grid grid-cols-4 items-center justify-between sm:justify-center text-gray-300 py-5 hover:bg-gray-500/10 hover:rounded-3xl hover:text-white transition-all duration-300 cursor-pointer"
							>
								<div className="col-span-1">
									<p className="p-3 font-semibold text-start md:text-center">{exp.period}</p>
								</div>
								<div className="col-span-3">
									<h2 className="text-xl lg:text-2xl text-white font-semibold italic pt-1 text-center lg:text-start">
										{exp.position} · {exp.company}
									</h2>
									{selectedExpIndex === index && (
										<motion.p
											variants={fadeIn("down")}
											initial="hidden"
											whileInView="show"
											viewport={{ once: false, amount: 0.4 }}
											className="pt-3">{exp.description}</motion.p>
									)}
								</div>
							</div>
						))}
					</motion.div>
				</div>
			</div>
		</section>
	);
};

export default Experiences;
